import { render, staticRenderFns } from "./RiskProfile.vue?vue&type=template&id=5e8752ba&"
import script from "./RiskProfile.vue?vue&type=script&lang=js&"
export * from "./RiskProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports